import React from 'react'
import './Faqsec.css'
import img from '../../assets/img-3.jpg'
import Accordion from 'react-bootstrap/Accordion'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Faqsec = () => {
  return (
    <div class="faq-section ws-section pb-lg-5">
                <div class="container">
                    <div class="row pb-5">
                        <div class="col-lg-6 mb-3">
                            <h2 class="ws-section_heading">Looking for Answers? Read Our FAQs</h2>
                            <img className='mb-5' src={img} alt=''/>
                            <a href="/courses/">
                            <button class="btn-primary btn-icon ms-0" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                       </a>
                        </div>
                        <div class="col-lg-6 align-self-center">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>How will Takshila courses help Fresh Graduates or VLSI Professionals?</Accordion.Header>
                                <Accordion.Body>
                                With the increasing complexity of chips and shrinking technology nodes, engineers are required to learn new skills or improve their skills for their career growth. We at Takshila Institute help you acquire new VLSI skills, improve your current skills, and increase your knowledge of the area you are currently working on.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Do you have placement assistance for your courses?</Accordion.Header>
                                <Accordion.Body>
                                We do have placement assistance for our students.  Takshila collaborates with some select top tier companies. Students get interview opportunities with these companies. However, this depends on the students’ performance.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>What are the salary expectations as a VLSI engineer?</Accordion.Header>
                                <Accordion.Body>
                                If you are a fresh graduate, you should expect from 4 to 6 lakhs. Product companies offer higher payments of up to 15 lakhs however, most of them higher from campuses.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>What kind of certificate does one receive after attending the program?</Accordion.Header>
                                <Accordion.Body>
                                You will be given a course completion certification from Takshila Institute, which is recognized by all VLSI Industry companies.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Why should I choose Takshila Institute of VLSI Technologies?</Accordion.Header>
                                <Accordion.Body>
                                Takshila as a training institute differentiates itself from other institutes in different ways. Our mentors are experts in the semiconductor industry who have worked extensively in various domains like Physical Design, Layout, CPU verification, Analog, and Mixed-signal, Verilog modeling, Memories, Low Power Design, and FPGA implementation using VHDL/Verilog,
Furthermore, we allow you to implement projects using standard tools required in the industry, which will help you increase the weight of your resume. Additionally, our fees are lesser when compared to other training institute in the country. Finally, our training’s are conducted both on weekdays and weekends giving you the opportunity to choose when fits you.
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                    <div class="row justify-content-center mt-5">
                        <div class="col-lg-12">
                        <div class="callaction-2">
                            <div class="row">
                                <div class="col-lg-6">
                                    <h1 className='mb-4'>REGISTER FOR DEMO CLASS</h1>
                                    <h1 className='mb-5'>FOR FREE</h1>
                                    <a href="/events/demo-class/">
                                    <button class="btn-primary btn-icon ms-0 mb-3" href="index.html#about">Click Here For Details<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                </a>
                                </div>
                                <div class="col-lg-6 align-self-center text-center">
                                
                                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                />
                                </div>
                                </div> 
                            </div>
                        </div>
                        
                    </div>
        </div>
    </div>
  )
}

export default Faqsec